import $ from "jquery";
$(document).ready(function () {
    if ($(".caldera-grid").length) {
        $("body").on("focus", ".form-group input, .form-group textarea, .form-group select", function (e) {
            $(e.currentTarget).parents('.form-group').addClass("active");
        });
        $("body").on("blur", ".form-group input, .form-group textarea, .form-group select", function (e) {
            var parent = $(e.currentTarget).parents('.form-group');
            parent.removeClass("active");
            if ($(e.currentTarget).val() != "")
                parent.addClass("completed");
            else
                parent.removeClass("completed");
        });
        $(".form-group").find(".form-control").trigger("blur");
        $("body").on("click", ".custom-submit button", function (e) {
            e.preventDefault();
            $(e.currentTarget).parent().next("input").trigger("click");
        });
        $('body').on("change", ".form-group .checkbox input, .form-group .checkbox-inline input", function (e) {
            if ($(e.currentTarget).is(":checked")) {
                $(e.currentTarget).parent(('label')).addClass("checked");
            }
            else {
                $(e.currentTarget).parent(('label')).removeClass("checked");
            }
        });
        if ($('.form-group .checkbox, .form-group .checkbox-inline').length) {
            if ($('.form-group .checkbox, .form-group .checkbox-inline').is(":checked")) {
                $('.form-group .checkbox, .form-group .checkbox-inline').addClass("checked");
            }
        }
    }
});
